import React, { FC, useState } from 'react';

import { useMutation } from '@apollo/react-hooks';
import { Box, TextField } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { CustomButton } from '../../../../components/UI/CustomButton';
import { INVITE_TO_TEAM } from '../../../../graphql/user';
import { Mutation } from '../../../../types';
import { emailRegexp } from '../../../../utils/regexps';
import useStyles from './styles';

interface InviteLearnerFormProps {
  setAlert: Function;
  teamId?: number;
}

const InviteLearnerForm: FC<InviteLearnerFormProps> = ({ setAlert, teamId }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [email, setEmail] = useState('');
  const [emailErr, setEmailErr] = useState('');

  const [sendTeamInviteEmail] = useMutation<Pick<Mutation, 'sendTeamInviteEmail'>>(INVITE_TO_TEAM, {
    onCompleted: () => {
      setAlert('alert.inviteSent');
    },
    variables: { team_id: teamId, email },
  });

  const validateForm = () => {
    let isValid = true;
    if (!email.trim()) {
      setEmailErr(t('error.fieldRequired'));
      isValid = false;
    }
    if (email.trim() && !emailRegexp.test(email)) {
      setEmailErr(t('error.emailIncorrect'));
      isValid = false;
    }
    return isValid;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      sendTeamInviteEmail();
    }
  };

  return (
    <Box className={classes.formWrap}>
      <Box className={classes.form}>
        <TextField
          name="email"
          variant="outlined"
          label={t('input.label.email')}
          className={classes.formField}
          value={email}
          onChange={(e) => {
            if (e.target.value) {
              setEmailErr('');
            }
            setEmail(e.target.value);
          }}
          error={!!emailErr}
          helperText={emailErr}
        />
      </Box>
      <CustomButton onClick={handleSubmit} btnClass={classes.btn}>
        {t('button.invite')}
      </CustomButton>
    </Box>
  );
};

export default InviteLearnerForm;
